import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { BoostIcon } from 'src/svgs/BoostIcon';
import { BoostIconLight } from 'src/svgs/BoostIconLight';

export const useBoostIcon = (useWhiteForDarkMode?: boolean) => {
  const { isDarkMode } = useSiteTheme();

  return isDarkMode ? BoostIconLight : BoostIcon;
};
